<script>
    import { onMount } from 'svelte'
    import { apiURL } from '../../store.js'
    import { compareDate } from '../../js/util.js'
    import { scrollToTop } from '../../js/hash-scroll.js'
    import NewsUpdate from '../content-types/NewsUpdate.svelte'

    const updates = fetch(`${apiURL}/api/v2/updates/`)
        .then(res => res.json())
        .then(obj => obj.items)

    onMount(() => {
        scrollToTop()
    })
</script>

<div id="updatesContent">
    {#await updates then updates}
        {#each updates.sort((a, b) => compareDate(a, b)) as update}
            <NewsUpdate {update} color={'#183CAF'} />
        {/each}
    {/await}
</div>

<style lang="scss">
    @import "../../styles/vars";

    #updatesContent {
        box-sizing: border-box;
        position: relative;
        width: 90vw;
        margin: 50px 5vw;
        top: 0;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 60px;
    }

    @include respond-to(phone) {
        #updatesContent {
            grid-template-columns: 1fr;
        }
    }
</style>
